// Generated by tools/pixellab/pack-gandhi-refactor.py.
export const GANDHI_FX = {
  "gandhi-counter": {
    "file": "../gandhi-refactor/gandhi-counter.png",
    "cols": 5,
    "rows": 2,
    "frames": 9,
    "fps": 15.873015873015873,
    "fill": 0.95
  },
  "gandhi-purify": {
    "file": "../gandhi-refactor/gandhi-purify.png",
    "cols": 5,
    "rows": 2,
    "frames": 8,
    "fps": 23.25581395348837,
    "fill": 0.95
  }
} as const;
export const SALT_SHEET = {
  "file": "/proto2d/gandhi-refactor/gandhi-salt-patch-shimmer.png",
  "cols": 4,
  "rows": 2,
  "frames": 8,
  "fps": 8
} as const;
